import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "border p-4 bg-gray-50 mb-6" }
const _hoisted_2 = {
  key: 0,
  class: "bg-orange-50 border border-orange-200 text-orange-700 p-4 rounded mb-4"
}
const _hoisted_3 = { class: "text-sm mt-2" }
const _hoisted_4 = { class: "text-lg font-semibold mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "bg-red-50 border border-red-200 text-red-700 p-3 rounded mb-4"
}
const _hoisted_6 = { class: "space-y-4" }
const _hoisted_7 = ["for"]
const _hoisted_8 = {
  key: 0,
  class: "text-red-500 ml-1"
}
const _hoisted_9 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_10 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_11 = ["id", "onUpdate:modelValue", "step", "disabled"]
const _hoisted_12 = {
  key: 0,
  class: "ml-2 text-gray-500"
}
const _hoisted_13 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 3,
  class: "flex items-center"
}
const _hoisted_16 = ["id", "onUpdate:modelValue", "disabled"]
const _hoisted_17 = ["for"]
const _hoisted_18 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_19 = {
  key: 1,
  class: "mt-1 text-xs text-amber-600"
}
const _hoisted_20 = { class: "flex justify-end space-x-2 mt-6" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]


import { useEquipment } from "@/composables/tasks/useEquipment";
import { useEquipmentForm } from "@/composables/tasks/useEquipmentForm";

// ===================================================================
// Emits
// ===================================================================

export default /*@__PURE__*/_defineComponent({
  __name: 'EquipmentAddForm',
  emits: ['cancel', 'saved'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

// ===================================================================
// Composables
// ===================================================================
// Equipment
const {
  getOptionLabel,
  isOptionModifiable,
} = useEquipment();

// Equipment Form
const {
  formState,
  selectedEquipmentType,
  handleSubmit,
} = useEquipmentForm();

// ===================================================================
// Actions
// ===================================================================
// Save new configuration
const saveNewConfig = async () => {
  await handleSubmit();
  emit('saved');
};

// Cancel adding
const cancelAddingConfig = () => {
  emit('cancel');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(selectedEquipmentType) && _unref(formState).selectedEquipmentTypeId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "font-medium" }, "Loading Equipment Configuration...", -1)),
          _createElementVNode("p", _hoisted_3, "Selected ID: " + _toDisplayString(_unref(formState).selectedEquipmentTypeId), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(selectedEquipmentType))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h2", _hoisted_4, " Add New " + _toDisplayString(_unref(selectedEquipmentType).name) + " Configuration ", 1),
          (Object.keys(_unref(formState).errors).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formState).errors, (errors, field) => {
                  return (_openBlock(), _createElementBlock("div", { key: field }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors, (error, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedEquipmentType).configOptions, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.name,
                class: "border-b pb-4"
              }, [
                _createElementVNode("label", {
                  for: `new-${option.name}`,
                  class: "block text-sm font-medium mb-2"
                }, [
                  _createTextVNode(_toDisplayString(_unref(getOptionLabel)(_unref(selectedEquipmentType).configOptions, option.name)) + " ", 1),
                  (option.required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_7),
                _createElementVNode("div", null, [
                  (option.type === 'text')
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        id: `new-${option.name}`,
                        "onUpdate:modelValue": ($event: any) => ((_unref(formState).values[option.name]) = $event),
                        type: "text",
                        class: "border border-gray-300 px-3 py-2 w-full",
                        disabled: _unref(formState).isSubmitting
                      }, null, 8, _hoisted_9)), [
                        [_vModelText, _unref(formState).values[option.name]]
                      ])
                    : (option.type === 'number')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            id: `new-${option.name}`,
                            "onUpdate:modelValue": ($event: any) => ((_unref(formState).values[option.name]) = $event),
                            type: "number",
                            step: option.name.toLowerCase().includes('needle') && option.name.toLowerCase().includes('size') ? '0.01' : 'any',
                            class: "border border-gray-300 px-3 py-2 w-full",
                            disabled: _unref(formState).isSubmitting
                          }, null, 8, _hoisted_11), [
                            [
                              _vModelText,
                              _unref(formState).values[option.name],
                              void 0,
                              { number: true }
                            ]
                          ]),
                          (option.unit)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(option.unit), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (option.type === 'select')
                        ? _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 2,
                            id: `new-${option.name}`,
                            "onUpdate:modelValue": ($event: any) => ((_unref(formState).values[option.name]) = $event),
                            class: "border border-gray-300 px-3 py-2 w-full",
                            disabled: _unref(formState).isSubmitting
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(option.options || [], (opt) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: opt,
                                value: opt
                              }, _toDisplayString(opt), 9, _hoisted_14))
                            }), 128))
                          ], 8, _hoisted_13)), [
                            [_vModelSelect, _unref(formState).values[option.name]]
                          ])
                        : (option.type === 'boolean')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _withDirectives(_createElementVNode("input", {
                                id: `new-${option.name}`,
                                "onUpdate:modelValue": ($event: any) => ((_unref(formState).values[option.name]) = $event),
                                type: "checkbox",
                                class: "h-4 w-4 border-gray-300 rounded",
                                disabled: _unref(formState).isSubmitting
                              }, null, 8, _hoisted_16), [
                                [_vModelCheckbox, _unref(formState).values[option.name]]
                              ]),
                              _createElementVNode("label", {
                                for: `new-${option.name}`,
                                class: "ml-2 text-sm text-gray-600"
                              }, _toDisplayString(option.label || "Enabled"), 9, _hoisted_17)
                            ]))
                          : _createCommentVNode("", true)
                ]),
                (_unref(formState).errors && _unref(formState).errors[option.name] && _unref(formState).errors[option.name].length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(formState).errors[option.name][0]), 1))
                  : _createCommentVNode("", true),
                (option.require_justification_for_change && _unref(isOptionModifiable)(option))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Note: Changes will require justification during task execution. "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: saveNewConfig,
              class: "bg-green-500 text-white hover:bg-green-600 px-4 py-2 text-sm font-medium rounded",
              disabled: _unref(formState).isSubmitting
            }, _toDisplayString(_unref(formState).isSubmitting ? 'Saving...' : 'Save Configuration'), 9, _hoisted_21),
            _createElementVNode("button", {
              onClick: cancelAddingConfig,
              type: "button",
              class: "bg-gray-500 text-white hover:bg-gray-600 px-4 py-2 text-sm font-medium rounded",
              disabled: _unref(formState).isSubmitting
            }, " Cancel ", 8, _hoisted_22)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})